import React from 'react';
import useAuth from '../../Hooks/useAuth'
const Select = ({data}) => {
  const {setSelectedBlockChain,setSelectedCategory,setSelectedPrice} = useAuth()
  const selectValue = (e,type) => {
    e.preventDefault()
    if (type==='Blockchains') {
      setSelectedBlockChain(e.target.value)
    }else if(type==='Category'){
      setSelectedCategory(e.target.value)
    }else if(type==='Price Range'){
      setSelectedPrice(e.target.value)
    }
  }

  return (
    <>
      <div className="select-content">
        <label className="select" htmlFor="slct">
          <select onChange={(e)=>selectValue(e,data?.selectName)} id="slct" required="required">
            <option disabled="disabled" defaultValue>
              {data?.selectName}
            </option>
            {
              data?.selectOptions?.map((option,i)=><option key={i} value={option?.optionValue}>{option?.optionName}</option>)
            }
          </select>
          <svg>
            <use xlinkHref="#select-arrow-down"></use>
          </svg>
        </label>
        <svg className="sprites">
          <symbol id="select-arrow-down" viewBox="0 0 10 6">
            <polyline points="1 1 5 5 9 1"></polyline>
          </symbol>
        </svg>
      </div>
    </>
  );
}

export default Select